import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Card, Dimmer, Dropdown, Button, Grid, Input, Loader, Icon} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {paths} from '../../../../common/dictionaries/urls';
import {pageSizes} from '../../../../common/constants/lists';
import ManualsOrdersTable from './table';
import './manualsOrders.scss';

class ManualsOrdersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'dealerSelected': '',
      'agencySelected': '',
      'filterPartCodeText': '',
      'filterOrderNumberText': '',
    };

    this.onCancelClick = this.onCancelClick.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onRefreshClick = this.onRefreshClick.bind(this);
    this.onPartCodeFilterChange = this.onPartCodeFilterChange.bind(this);
    this.onOrderNumberChange = this.onOrderNumberChange.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.PickingManualsOrders, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearData('ALL');
    this.props.changeOrdersListPageSize(pageSizes[0].value);
    this.props.updateOrders();
    this.props.fetchPickingDealers();
    this.props.fetchPickingAgencies();
  }

  onCancelClick() {
    this.setState({
      'dealerSelected': '',
      'agencySelected': '',
      'filterPartCodeText': '',
      'filterOrderNumberText': '',
    });
    this.clearOrders();
  }

  onSearch() {
    const {dealerSelected, agencySelected, filterPartCodeText, filterOrderNumberText} = this.state;
    let agency = '';
    if (agencySelected) {
      agency = agencySelected.split('-')[0];
    }
    const filters = {
      'dealer': dealerSelected,
      agency,
      'part': filterPartCodeText,
      'order': filterOrderNumberText,
    };
    this.props.fetchOrders(filters);
  }

  buildItemsForDealersList() {
    return this.props.dealers.map((dealer) => {
      return {'text': dealer.name, 'value': dealer.identification};
    });
  }

  changeDealer(value) {
    if (value === this.state.dealerSelected) {
      return;
    }
    this.setState({
      'dealerSelected': value,
      'agencySelected': '',
    });
    this.clearOrders();
  }

  buildItemsForAgenciesList() {
    const {dealerSelected} = this.state;
    const {agencies} = this.props;
    let agenciesFiltered = agencies;

    if (dealerSelected) {
      agenciesFiltered = _.filter(agencies, {'dealerId': dealerSelected});
    }
    return agenciesFiltered.map((agency) => {
      return {'text': agency.name, 'value': `${agency.code}-${agency.dealerId}`};
    });
  }

  changeAgency(value) {
    const {dealerSelected, agencySelected} = this.state;
    if (value === agencySelected) {
      return;
    }
    const newState = {'agencySelected': value};
    if (!dealerSelected) {
      const dealerSelectedSeparated = value.split('-');
      newState.dealerSelected = dealerSelectedSeparated[1];
    }
    this.setState(newState);
    this.clearOrders();
  }

  clearOrders() {
    this.props.clearData('ORDERS');
  }

  onRefreshClick() {
    this.setState({
      'dealerSelected': '',
      'agencySelected': '',
    });
    this.props.clearData('ALL');
    this.props.fetchPickingDealers();
    this.props.fetchPickingAgencies();
  }

  onPartCodeFilterChange(event) {
    this.setState({'filterPartCodeText': (event.target.value).toUpperCase()});
  }

  onOrderNumberChange(event) {
    this.setState({'filterOrderNumberText': (event.target.value).toUpperCase()});
  }

  render() {
    const {updatingOrders, loadingDealers, loadingAgencies, loadingOrders} = this.props;
    const {dealerSelected, agencySelected, filterPartCodeText, filterOrderNumberText} = this.state;

    return (
      <div className='specials-orders-list'>
        <Card raised fluid>
          <Dimmer inverted active={updatingOrders}><Loader>Actualizando Pedidos</Loader></Dimmer>
          <div className='title-bar'>
            <div className='title'>
              <h2>Pedidos Manuales</h2>
              <div className='title-bar-actions'>
                <Button
                  type='button'
                  secondary
                  className='toyota-secondary'
                  disabled={
                    loadingOrders ||
                    (!dealerSelected && !agencySelected && !filterPartCodeText && !filterOrderNumberText)
                  }
                  onClick={this.onCancelClick}
                >
                  Limpiar
                </Button>
                <Button
                  primary
                  type='submit'
                  className='toyota-primary'
                  disabled={
                    loadingOrders || !(dealerSelected || agencySelected || filterPartCodeText || filterOrderNumberText)
                  }
                  onClick={this.onSearch}
                >
                  Buscar
                </Button>
              </div>
            </div>

            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={2}>
                    <h4>Concesionario</h4>
                  </Grid.Column>
                  <Grid.Column width={5}>
                    <Dropdown selection
                      options={this.buildItemsForDealersList()}
                      search
                      value={dealerSelected}
                      disabled={loadingDealers || loadingAgencies}
                      loading={loadingDealers}
                      onChange={(e, {value}) => this.changeDealer(value)}
                      placeholder='Seleccione Concesionario'
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <Button
                      type='button'
                      primary
                      className='toyota-primary refresh'
                      onClick={this.onRefreshClick}
                    >
                      <Icon name='refresh' size='large' />
                    </Button>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Código Parte</h4>
                  </Grid.Column>
                  <Grid.Column width={5}>
                    <Input
                      placeholder='Código Parte'
                      value={filterPartCodeText}
                      onChange={this.onPartCodeFilterChange}
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={2}>
                    <h4>Agencia</h4>
                  </Grid.Column>
                  <Grid.Column width={5}>
                    <Dropdown selection
                      options={this.buildItemsForAgenciesList()}
                      search
                      value={agencySelected}
                      disabled={loadingDealers || loadingAgencies}
                      loading={loadingAgencies}
                      onChange={(e, {value}) => this.changeAgency(value)}
                      placeholder='Seleccione Agencia'
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>No. pedido</h4>
                  </Grid.Column>
                  <Grid.Column width={5}>
                    <Input
                      placeholder='No. pedido'
                      value={filterOrderNumberText}
                      onChange={this.onOrderNumberChange}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
            
          </div>
        </Card>
        <ManualsOrdersTable />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'updatingOrders': state.manualsOrders.updatingOrders,
    'loadingDealers': state.manualsOrders.loadingDealers,
    'dealers': state.manualsOrders.dealersList,
    'loadingAgencies': state.manualsOrders.loadingAgencies,
    'agencies': state.manualsOrders.agenciesList,
    'loadingOrders': state.manualsOrders.loadingOrders,
    'orders': state.manualsOrders.ordersListByPage,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  updateOrders,
  clearData,
  fetchPickingDealers,
  fetchPickingAgencies,
  fetchOrders,
  changeOrdersListPageSize,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  updateOrders,
  clearData,
  fetchPickingDealers,
  fetchPickingAgencies,
  fetchOrders,
  changeOrdersListPageSize,
  navigateTo,
})(ManualsOrdersList);
